// extracted by mini-css-extract-plugin
export var copy = "fc-copy-block-page-module--copy--022c2";
export var root = "fc-copy-block-page-module--root--eb53a";